// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 全体のコンテナ */
.progress-bar {
  width: 100%; /* 全幅 */
  height: 16px;
  background-color: var(--input-bg-color); /* 背景色 */
  border-radius: 4px; /* 丸み */
  overflow: hidden; /* 子要素がはみ出さないように */
  position: relative;
  --main-progress: 0%;
  --sub-progress: 0%;
  /* プログレス部分 */
  /* プログレス部分 */
}
.progress-bar .progress {
  width: var(--main-progress);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: width 1s ease-in-out; /* アニメーションの滑らかさ */
  background-color: var(--primary-color-main);
  z-index: var(--z-index-local-over-2);
}
.progress-bar .sub-progress {
  width: var(--sub-progress);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: width 1.5s ease-in-out; /* アニメーションの滑らかさ */
  background-color: var(--warning-color-main);
  z-index: var(--z-index-local-over-1);
}
@keyframes progressAnim {
  0% {
    width: 0%;
  }
  99.9%, to {
    width: var(--main-progress);
  }
}
@keyframes subProgressAnim {
  0% {
    width: 0%;
  }
  99.9%, to {
    width: var(--sub-progress);
  }
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/ProgressBar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,YAAA;AACA;EACE,WAAA,EAAA,OAAA;EACA,YAAA;EACA,uCAAA,EAAA,QAAA;EACA,kBAAA,EAAA,OAAA;EACA,gBAAA,EAAA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,YAAA;EAiBA,YAAA;AAhBF;AAAE;EACE,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EAEA,gCAAA,EAAA,iBAAA;EACA,2CAAA;EAEA,oCAAA;AAAJ;AAME;EACE,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EAEA,kCAAA,EAAA,iBAAA;EACA,2CAAA;EAEA,oCAAA;AANJ;AAWE;EACE;IACE,SAAA;EATJ;EAWE;IACE,2BAAA;EATJ;AACF;AAYE;EACE;IACE,SAAA;EAVJ;EAYE;IACE,0BAAA;EAVJ;AACF","sourcesContent":["/* 全体のコンテナ */\r\n.progress-bar {\r\n  width: 100%; /* 全幅 */\r\n  height: 16px;\r\n  background-color: var(--input-bg-color); /* 背景色 */\r\n  border-radius: 4px; /* 丸み */\r\n  overflow: hidden; /* 子要素がはみ出さないように */\r\n  position: relative;\r\n\r\n  --main-progress: 0%;\r\n  --sub-progress: 0%;\r\n\r\n  /* プログレス部分 */\r\n  .progress {\r\n    width: var(--main-progress);\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n\r\n    transition: width 1.0s ease-in-out; /* アニメーションの滑らかさ */\r\n    background-color: var(--primary-color-main);\r\n\r\n    z-index: var(--z-index-local-over-2);\r\n    \r\n    // animation: progressAnim 1s forwards;\r\n  }\r\n\r\n  /* プログレス部分 */\r\n  .sub-progress {\r\n    width: var(--sub-progress);\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n\r\n    transition: width 1.5s ease-in-out; /* アニメーションの滑らかさ */\r\n    background-color: var(--warning-color-main);\r\n\r\n    z-index: var(--z-index-local-over-1);\r\n\r\n    // animation: subProgressAnim 1.5s forwards;\r\n  }\r\n\r\n  @keyframes progressAnim {\r\n    0% {\r\n      width: 0%;\r\n    }\r\n    99.9%, to {\r\n      width: var(--main-progress);\r\n    }\r\n  }\r\n\r\n  @keyframes subProgressAnim {\r\n    0% {\r\n      width: 0%;\r\n    }\r\n    99.9%, to {\r\n      width: var(--sub-progress);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
